/**
 * @generated SignedSource<<23e4452876d50c7767a79024bb759fde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanionModeLandingPageQuery$variables = {};
export type CompanionModeLandingPageQuery$data = {
  readonly viewer: {
    readonly uxSimplificationEnabled: boolean;
  };
};
export type CompanionModeLandingPageQuery = {
  response: CompanionModeLandingPageQuery$data;
  variables: CompanionModeLandingPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uxSimplificationEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanionModeLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CompanionModeLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6417eb398ea0a9c32295e38510ef75a",
    "id": null,
    "metadata": {},
    "name": "CompanionModeLandingPageQuery",
    "operationKind": "query",
    "text": "query CompanionModeLandingPageQuery {\n  viewer {\n    uxSimplificationEnabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ba3cd534a5c00001036f2b564c4d5cc";

export default node;
